import { render, staticRenderFns } from "./BlockDateCards.vue?vue&type=template&id=4f120bcb&"
import script from "./BlockDateCards.vue?vue&type=script&lang=js&"
export * from "./BlockDateCards.vue?vue&type=script&lang=js&"
import style0 from "./BlockDateCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports